<template lang="pug">
form(@submit.prevent="submit" novalidate)
  .modal-card
    header.modal-card-head
      p.modal-card-title(v-once) {{ title }}
    section.modal-card-body
      b-field(
        label="Name"
        :message="errors.has('name') ? errors.first('name') : ''"
        :type="errors.has('name') ? 'is-danger' : ''"
      )
        b-input(
          name="name"
          :value="member.name"
          v-validate="'required'"
          @input="set($event, 'name')"
        )
      b-field(
        label="Phone Number"
        :message="errors.has('phone_number') ? errors.first('phone_number') : ''"
        :type="errors.has('phone_number') ? 'is-danger' : ''"
      )
        phone-field(
          name="phone_number"
          data-vv-as="phone number"
          v-validate="{ required: true, unique: { id: member.id, resource: 'members', fieldName: 'phone_number' } }"
          :value="member.phone_number"
          @input="set($event, 'phone_number')"
        )
      b-field(style="padding-top:0.35rem;")
        b-switch(
          type="is-success"
          :value="member.is_approved"
          @input="set($event, 'is_approved')"
        )
          span {{ member.is_approved ? 'Approved' : 'Not Approved' }}
    footer.modal-card-foot
      button.button.is-success(
        type="submit"
        :class="{ 'is-loading': settings.submitting }"
      ) Save Church Member
</template>

<script>
import { mapGetters } from 'vuex';
import PhoneField from '@/components/form/PhoneField';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'member-form',
  components: {
    PhoneField,
  },
  computed: {
    ...mapGetters({
      member: getters.GET_MEMBER,
    }),
    isNew() {
      return this.member.id === undefined;
    },
    title() {
      return this.isNew ? 'New Church Member' : `Edit Church Member: ${this.member.name}`;
    },
  },
  data() {
    return {
      settings: {
        submitting: false,
      },
    };
  },
  methods: {
    set(val, key) {
      this.$store.commit(mutations.SET_MEMBER_FIELD, {
        key,
        val,
      });
    },
    async submit() {
      const valid = await this.$validator.validateAll();
      if (valid) {
        this.settings.submitting = true;
        const action = this.isNew ? actions.DO_CREATE_MEMBER : actions.DO_UPDATE_MEMBER;
        const payload = {
          id: this.member.id,
          is_approved: this.member.is_approved,
          name: this.member.name,
          phone_number: this.member.phone_number,
          verify: false,
        };
        const response = await this.$store.dispatch(action, payload);
        setTimeout(() => {
          this.$parent.close();
          this.$store.commit(mutations.SET_APP_SNACKBAR, {
            type: 'is-success',
            message: response.message,
          });
          this.settings.submitting = false;
          this.$store.commit(mutations.SET_MINISTRY_REFRESH, true);
        }, 1000);
      }
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/form/MemberForm.vue